/* eslint-disable max-lines */
import { getSettingItem } from './storage';

var moment = require('moment-jalaali');
const SEVEN_DAYS = 6 * 24 * 60 * 60 * 1000;

export const getFullYear = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jYYYY');
    }
    return moment(date).format('YYYY');
};
export const getMonth = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jM');
    }
    return moment(date, 'YYYY-MM-DD').format('M');
};
export const getDay = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jD');
    }
    return moment(date).format('D');
};
export const getDayOfWeek = (date) => {
    if (!date) {
        return;
    }
    const orderOfDaysInMilaadi = [
        'یکشنبه',
        'دوشنبه',
        'سه‌شنبه',
        'چهارشنبه',
        'پنج‌شنبه',
        'جمعه',
        'شنبه'
    ];
    const daysInMilaadi = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'saturday'];
    const day = moment(date).day();
    if (isDateInJalaali()) {
        return orderOfDaysInMilaadi[day];
    }
    return daysInMilaadi[day];
};
export const getFullDayName = (date) => {
    if (!date) {
        return;
    }
    return moment(date).format('dddd');
};
export const getMonthName = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return mapPersianMonthNumToName(+moment(date).format('jM'));
    }
    return mapMilaadiMonthNumToName(+moment(date).format('M'));
};
export const getFullDateTime = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jYYYY/jM/jD HH:mm');
    }
    return moment(date).format('YYYY/M/D HH:mm');
};

export const getFullDateTimeWithMoreSpace = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jYYYY/jM/jD \u00A0\u00A0 HH:mm');
    }
    return moment(date).format('YYYY/M/D \u00A0\u00A0 HH:mm');
};
export const fullDateWithMonthName = (date) => {
    if (!date) {
        return;
    }
    return getDay(date) + ' ' + getMonthName(date) + ' ' + getFullYear(date);
};
export const getDateWithMonthName = (date) => {
    if (!date) {
        return;
    }
    return getDay(date) + ' ' + getMonthName(date);
};
export const getFullDate = (date) => {
    if (!date) {
        return;
    }
    if (date._isAMomentObject) {
        if (isDateInJalaali()) {
            return date.format('jYYYY/jM/jD');
        }
        return date.format('YYYY/M/D');
    }
    if (isDateInJalaali()) {
        return moment(date, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');
    }
    return moment(date, 'YYYY-MM-DD').format('YYYY/M/D');
};

export const getAgeWithUnit = (date) => {
    if (!date) {
        return;
    }
    let yearUnitText = 'سال';
    let monthUnitText = 'ماه';
    let dayUnitText = 'روز';
    if (!isDateInJalaali()) {
        yearUnitText = 'year';
        monthUnitText = 'month';
        dayUnitText = 'day';
    }
    const today = new Date();
    if (moment(new Date()).diff(date, 'years') > 0) {
        return { age: moment(today).diff(date, 'years'), unit: yearUnitText };
    } else if (moment(today).diff(date, 'months') > 0) {
        return { age: moment(today).diff(date, 'months'), unit: monthUnitText };
    } else if (moment(today).diff(date, 'days') > 0) {
        return { age: moment(today).diff(date, 'days'), unit: dayUnitText };
    } else {
        return { age: 'coming', unit: 'soon!' };
    }
};
export const getTime = (date) => {
    if (!date) {
        return;
    }
    return moment(date).format('HH:mm');
};
export const getHour = (date) => {
    if (!date) {
        return;
    }
    return moment(date).format('HH');
};
export const getMinute = (date) => {
    if (!date) {
        return;
    }
    return moment(date).format('mm');
};
function mapPersianMonthNumToName(monthNum) {
    return jalaaliMonths[monthNum - 1];
}
function mapMilaadiMonthNumToName(monthNum) {
    return milaadiMonths[monthNum - 1];
}
export const jalaaliMonths = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند'
];
export const jalaaliDaysOfWeek = [
    { label: 'شنبه', index: 0 },
    { label: 'یک‌شنبه', index: 1 },
    { label: 'دوشنبه', index: 2 },
    { label: 'سه‌شنبه', index: 3 },
    { label: 'چهارشنبه', index: 4 },
    { label: 'پنج‌شنبه', index: 5 },
    { label: 'جمعه', index: 6 }
];
export const milaadiDaysOfWeek = [
    { label: 'Monday', index: 0 },
    { label: 'Tuesday', index: 1 },
    { label: 'Wednesday', index: 2 },
    { label: 'Thursday', index: 3 },
    { label: 'Friday', index: 4 },
    { label: 'Saturday', index: 5 },
    { label: 'Sunday', index: 6 }
];
export const milaadiMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const getFullWeek = (date) => {
    // const dateName = getFullDayName(date);
    const convertedDate = moment(new Date(date));
    const indexDate = convertedDate.day();
    // let indexDate = daysOfWeek.indexOf(dateName);
    // if (isDateInJalaali()) {
    //     indexDate = daysOfWeek.indexOf(dateName);
    // } else {
    //     indexDate = milaadiDaysOfWeek.indexOf(dateName);
    // }
    if (isDateInJalaali()) {
        return getJalaaliWeek(indexDate, date);
    } else {
        return getMilaadiWeek(indexDate, date);
    }
};
export const getJalaaliWeek = (indexDate, date) => {
    let week = [];
    for (let i = 0; i < 7; i++) {
        if (indexDate - i > 0) {
            const prevDay = moment(date)
                .subtract(indexDate - i, 'days')
                .format('YYYY-MM-DD');
            week.push(prevDay);
        } else {
            const nextDay = moment(date)
                .add(i - indexDate, 'days')
                .format('YYYY-MM-DD');
            week.push(nextDay);
        }
    }
    const firstDay = moment(week[0]).subtract(1, 'days').format('YYYY-MM-DD');
    week.unshift(firstDay);
    week.splice(-1, 1);
    return week;
};
export const getMilaadiWeek = (indexDate, date) => {
    let week = [];
    for (let i = 0; i < 7; i++) {
        if (indexDate - i > 0) {
            const prevDay = moment(date)
                .subtract(indexDate - i, 'days')
                .format('YYYY-MM-DD');
            week.push(prevDay);
        } else {
            const nextDay = moment(date)
                .add(i - indexDate, 'days')
                .format('YYYY-MM-DD');
            week.push(nextDay);
        }
    }
    week.splice(0, 1);
    const lastDay = moment(week[week.length - 1])
        .add(1, 'days')
        .format('YYYY-MM-DD');
    week.push(lastDay);
    return week;
};
export const getFullDateTimeConcatenated = (date) => {
    if (!date) {
        return;
    }
    if (isDateInJalaali()) {
        return moment(date).format('jYYYY-jMM-jDD_HH-mm-ss');
    }
    return moment(date).format('YYYY-MM-DD_HH-mm-ss');
};
const isDateInJalaali = () => {
    const lang = getSettingItem('lang');
    if (lang === 'fa') {
        return true;
    }
    return false;
};

export const getWeek = (day1, day2) => {
    if (!day1 || !day2) {
        return;
    }
    return getDay(day1) + ' - ' + getDay(day2) + ' ' + getMonthName(day1) + ' ' + getFullYear(day1);
};
export const getMonthNameWithYear = (date) => {
    if (!date) return;
    const lang = getSettingItem('lang');
    if (lang === 'fa') {
        const splitDate = date.split('-');

        return jalaaliMonths[parseInt(splitDate[1]) - 1];
    }
    return getMonthName(date);
};
export const convertDateToIsoType = (date) => {
    const newDate = new Date(date);
    return newDate.toISOString().slice(0, 10);
};
export const todayOrLastWeek = (isLastWeek) => {
    const today = new Date();
    const lastWeek = new Date(today.getTime() - SEVEN_DAYS);
    const date = isLastWeek ? lastWeek : today;
    return date.toISOString().slice(0, 10);
};
export const getDateToJalaaliWithDash = (date) => {
    const newDate = new Date(date);
    return moment(newDate).format('jYYYY-jMM-jDD');
};
export const getRangeDates = (v1, v2, isJalali = false) => {
    const start = new Date(v1);
    const end = new Date(v2);
    let d1, d2;
    if (start > end) {
        d1 = end;
        d2 = start;
    } else {
        d2 = end;
        d1 = start;
    }
    const arr = [];
    let dt;
    for (arr, dt = new Date(d1); dt <= d2; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
    }
    arr.push(d2);

    return arr.map((item) =>
        isJalali
            ? getDateToJalaaliWithDash(item.toISOString().slice(0, 10))
            : item.toISOString().slice(0, 10)
    );
};
const PersianDays = ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
const EnglishDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const getDayWithWeekName = (date) => {
    if (!date) {
        return;
    }
    const newDate = new Date(date);
    const days = isDateInJalaali() ? PersianDays : EnglishDays;

    return days[newDate.getDay()] + ' - ' + getDay(date) + ' ' + getMonthName(date);
};

export const monthDiff = (v1, v2) => {
    const start = new Date(v1);
    const end = new Date(v2);
    let d1, d2;
    if (start > end) {
        d1 = end;
        d2 = start;
    } else {
        d2 = end;
        d1 = start;
    }
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
};
